import { Component, Input, TemplateRef, ChangeDetectionStrategy } from "@angular/core";
import { ISearchResponseRow, ISearchResultRenderer } from "../../quick-search.models";

@Component({
    selector: "rask-no-result-renderer",
    templateUrl: "./no-result-renderer.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./no-result-renderer.component.scss"]
})
export class NoResultRendererComponent implements ISearchResultRenderer {

    @Input() input: ISearchResponseRow;
    @Input() tooltipTemplate: TemplateRef<any>;

}
